import React from "react";
import { connect } from "react-redux";
import { setIsOnlyCamera } from "../../stories/actions";
import * as roomRTC from "../../services/roomRTC";

const ButtonCam = ({ isOnlyCamera, setIsOnlyCameraAction }) => {
    const handlerStateCam = () => {
        setIsOnlyCameraAction(!isOnlyCamera);
        
        let cameraActive = isOnlyCamera ? false : true;
        roomRTC.toggleCameraConnect(cameraActive);
    };

    return (
        <div className="btn_cam_circle" onClick={handlerStateCam}>
            {isOnlyCamera ?
                <span className="material-symbols-outlined btn_icon_style" title='Câmera ligada'>videocam</span> :
                <span className="material-symbols-outlined btn_icon_style" title='Câmera desligada'>videocam_off</span>}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        ...state
    };
};

const mapStateActionToProps = (dispatch) => {
    return {
        setIsOnlyCameraAction: (isOnlyCamera) => dispatch(setIsOnlyCamera(isOnlyCamera)),
    };
};

export default connect(mapStateToProps, mapStateActionToProps)(ButtonCam);